module.exports = __webpack_public_path__ + "img/google-plus-icon.1d8cc4a9.png";